// extracted by mini-css-extract-plugin
export default {"vividSkyBlue":"#48c8ea"};